import { IconButton, IconButtonProps, SvgIconProps } from '@mui/material';

import CloseIcon from '../../../assets/icons/Close';

interface AlertCloseButtonProps extends IconButtonProps {
  // These icon buttons always appear on Snackbar or Alert components and they always
  // have a color background that we need to use as a base for the hover colors
  baseColor: string;
  iconProps?: SvgIconProps;
}

const AlertCloseButton = ({
  baseColor,
  iconProps,
  sx,
  ...props
}: AlertCloseButtonProps) => {
  return (
    <IconButton
      disableRipple
      {...props}
      sx={{
        '&:hover': {
          backgroundColor: `${baseColor}33`, // 20% opacity applied to the baseColor
        },
        ...sx,
      }}
    >
      <CloseIcon {...iconProps} />
    </IconButton>
  );
};

export default AlertCloseButton;
